import React from "react";
import { StateDispatchProps } from "../state-dispatch.props";

export type QqQuizContainerProps = StateDispatchProps;

export const QqQuizRawContainerComponent: React.FunctionComponent<QqQuizContainerProps> =
  ({ children }) => {
    return <div>{children}</div>;
  };
